export default __webpack_public_path__ + "static/media/usEmbassy.e8dcc140.png";